<template>
    <modal
        v-if="isActive"
        :show="showModal"
        :title="title"
        :needFooter="false"
        :centered="true"
        :contentCentered="true"
        :hasBackdrop="false"
        :draggable="true"
        size="small"
        @close="onClose"
        :saveButton="{
            visible: false
        }"
        :cancelButton="{
            visible: false
        }"
        class="modal-measure">
        <div class="panel-control d-flex flex-column flex-fill">
            <div class="panel-control-content d-flex flex-column flex-fill">
                <div class="row">
                    <div class="col-12">
                        <div class="btn-toolbar w-100 justify-content-center" role="toolbar" aria-label="">
                            <div class="btn-group btn-block" role="group" aria-label="Actions">
                                <button
                                    v-for="(action, key) in activeActions"
                                    :key="key"
                                    :title="action.title"
                                    @click.stop="applyAction(key, $event)"
                                    type="button"
                                    class="btn btn-secondary-main min-w-auto mx-0"
                                    :class="{'active': actionType == key}"
                                    data-toggle="tooltip-city"
                                >
                                    <i class="" :class="action.icon"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
    import ButtonControlMixin from '../mixins/ButtonControlMixin';
    import { MAP_ACTIONS } from '@config/constants';
    import MapBrowserEventType from 'ol/MapBrowserEventType';
    import {LineString, Polygon} from 'ol/geom';
    import {getArea, getLength} from 'ol/sphere';
    import {unByKey} from 'ol/Observable';
    import Overlay from 'ol/Overlay';

    let vars = {
        interaction: null,
        /**
         * Currently drawn feature.
         * @type {import("ol/Feature.js").default}
         */
        sketch: null,
        /**
         * Listener sketch Geometry
         */
        listener: null,
        /**
         * The help tooltip element.
         * @type {HTMLElement}
         */
        helpTooltipElement: null,
        /**
         * The help tooltip id.
         * @type {string}
         */
        helpTooltipId: 'ol-tooltip-measure-help',
        /**
         * Overlay to show the help messages.
         * @type {Overlay}
         */
        helpTooltip: null,
        /**
         * The measure tooltip element.
         * @type {string}
         */
        measureTooltipElement: null,
        /**
         * The measure tooltip id.
         * @type {Overlay}
         */
        measureTooltipId: 'ol-tooltip-measure',
        /**
         * Overlay to show the measurement.
         * @type {Overlay}
         */
        measureTooltip: null,
        /**
         * Message to show when the user is drawing a polygon.
         * @type {string}
         */
        continuePolygonMsg: 'Click to continue drawing the polygon',
        /**
         * Message to show when the user is drawing a line.
         * @type {string}
         */
        continueLineMsg: 'Click to continue drawing the line',
        /**
         * Message to show before user is drawing.
         * @type {string}
         */
        helpMsg: 'Click to start drawing',
    };

    export default {
        components:{
            Modal: () => import(/* webpackChunkName: "modal" */ '@/app/shared/components/modals/Modal'),
        },
        mixins: [
            ButtonControlMixin,
        ],
        props: {
            closeBtn: {
                type: Boolean,
                default: true
            },
            actionName: {
                type: String,
                default: MAP_ACTIONS.MEASURE,
            },
        },
        data() {
            return {
                idPanel: 'measure',
                className: 'ol-measure',
                actionType: null,
                actions: {
                    length: {
                        title: 'Medir a distância',
                        icon: 'fas fa-project-diagram', //<i class="fab fa-cloudsmith"></i><i class="fas fa-project-diagram"></i>
                        default: true,
                        active: true,
                    },
                    area: {
                        title: 'Medir a área',
                        icon: 'fas fa-draw-polygon',
                        default: false,
                        active: true,
                    },
                    bearing: {
                        title: 'Exportar Anotações',
                        icon: 'fas fa-cloud-download-alt',
                        default: false,
                        active: false,
                    },
                    remove: {
                        title: 'Limpar Medições',
                        icon: 'fas fa-trash-alt',
                        default: false,
                        active: true,
                    },
                },

            }
        },
        computed: {
            showModal() {
                return this.isActive && this.isPanelVisible;
            },
            activeActions() {
                const filtered = Object.entries(this.actions).filter(([key, value]) => value.active);
                return Object.fromEntries(filtered);
            },
            configMap() {
                return this.moduleCode ? this.$store.getters.getConfigMap(this.moduleCode) : {};
            },
            layersProperties() {
                return this.configMap.layers ? this.configMap.layers.measure : {};
            },
            sourceId() {
                return this.layersProperties.source || {};
            },
            layerId() {
                return this.layersProperties.layer || {};
            },
        },
        beforeDestroy() {
            this.reset();
        },
        methods: {
            addButtonMap: function(_map){
                let btn = _map.createBtnImg(
                    this.assetsPathTheme('/map/ruler.svg'),
                    _map.getControlClassName(this.orderClassName),
                    this.title,
                    [
                        {
                            type: 'click',
                            event: (evt) => {
                                this.openPanel(this.idPanel);
                                evt.stopPropagation();
                            }
                        }
                    ],
                    this.lblBtn
                );
                _map.addControl(this.posBtnMap, btn);
                this.$eventBus.listen(this.moduleCode, 'map.new-feature-initialize', (evt)=>{
                    let el = $(btn.element); if(el) el.hide()
                });
                this.$eventBus.listen(this.moduleCode, 'map.new-feature-finished', (evt)=>{
                    let el = $(btn.element); if(el) el.show()
                });
                return btn;
            },
            initialize: function() {
                this.setMapLayer();
                this.setDefaultAction();
                this.createMeasureTooltip();
                this.createHelpTooltip();
                this.setMapHandler();
                this.setActionMap();
            },
            reset: function(){
                this.removeMapInteraction();
                this.removeTooltips();
                this.setMapHandler(true);
                this.setMapLayer(true);
                vars.listener = null;
                this.actionType = null;
                this.setActionMap(true);
            },
            onClose: function() {
                this.closePanel(this.idPanel);
            },
            setActionMap: function(reset=false) {
                this.$store.dispatch(`setActionMap`, {module: this.moduleCode, action: reset ? null : this.actionName});
            },
            setDefaultAction: function(){
                let key = Object.keys(this.activeActions).find(key => this.activeActions[key].default);
                if(key) {
                    this.applyAction(key);
                }
            },
            applyAction: function(key, evt) {
                this.hideTooltip();
                switch(key) {
                    case 'length':
                    case 'area':
                        this.actionType = key;
                        this.createInteraction(key);
                        break;
                    case 'remove':
                        this.clearMap();
                        break;
                    default:
                        this.actionType = null;
                };
            },
            createInteraction(typeSelect = 'length'){
                const type = typeSelect == 'area' ? 'Polygon' : 'LineString';
                let _map = this.getMap();
                if(_map) {
                    this.removeMapInteraction();
                    let _source = _map.getSource(this.sourceId);
                    if(_source){
                        let draw = _map.createDraw({
                            source: _source,
                            type: type,
                            style: _map.createStyle({
                                fill: {
                                    color: 'rgba(255, 255, 255, 0.2)',
                                },
                                stroke: {
                                    color: 'rgba(0, 0, 0, 0.5)',
                                    width: 2,
                                    lineDash: [10, 10],
                                },
                                circle: {
                                    radius: 5,
                                    stroke: 'rgba(0, 0, 0, 0.7)',
                                    fill: 'rgba(255, 255, 255, 0.2)',
                                },
                            })
                        });
                        draw.on('drawstart', (evt) => {
                            // set sketch
                            vars.sketch = evt.feature;

                            /** @type {import("ol/coordinate.js").Coordinate|undefined} */
                            let tooltipCoord = evt.coordinate;

                            vars.listener = vars.sketch.getGeometry().on('change', (evt) => {
                                const geom = evt.target;
                                let output;
                                if (geom instanceof Polygon) {
                                    output = this.formatArea(geom);
                                    tooltipCoord = geom.getInteriorPoint().getCoordinates();
                                } else if (geom instanceof LineString) {
                                    output = this.formatLength(geom);
                                    tooltipCoord = geom.getLastCoordinate();
                                }
                                if(vars.measureTooltipElement){
                                    vars.measureTooltipElement.innerHTML = output;
                                }
                                if(vars.measureTooltip){
                                    vars.measureTooltip.setPosition(tooltipCoord);
                                }
                            });
                        });
                        draw.on('drawend', (evt) => {
                            let measureTooltipElement = vars.measureTooltipElement;
                            if(measureTooltipElement){
                                measureTooltipElement.className = 'ol-tooltip ol-tooltip-static';
                            }

                            let measureTooltip = vars.measureTooltip;
                            if(measureTooltip){
                                measureTooltip.setOffset([0, -7]);
                            }
                            // unset sketch
                            vars.sketch = null;
                            // unset tooltip so that a new one can be created
                            vars.measureTooltipElement = null;
                            this.createMeasureTooltip();
                            unByKey(vars.listener);
                        });
                        draw.setActive(true);
                        _map.addInteraction(draw);
                        vars.interaction = draw;
                    }
                }
            },
            removeMapInteraction: function() {
                let interaction = vars.interaction;
                if(interaction){
                    interaction.setActive(false);
                    let _map = interaction.getMap();
                    if(_map) {
                        _map.removeInteraction(interaction);
                    }
                }
                vars.interaction = null;
            },
            formatLength: function(line) {
                const length = getLength(line);
                let output;
                if (length > 100) {
                    output = Math.round((length / 1000) * 100) / 100 + ' ' + 'km';
                } else {
                    output = Math.round(length * 100) / 100 + ' ' + 'm';
                }
                return output;
            },
            formatArea: function(polygon) {
                const area = getArea(polygon);
                let output;
                if (area > 10000) {
                    output = Math.round((area / 1000000) * 100) / 100 + ' ' + 'km<sup>2</sup>';
                } else {
                    output = Math.round(area * 100) / 100 + ' ' + 'm<sup>2</sup>';
                }
                return output;
            },
            createHelpTooltip: function() {
                let _map = this.getMap();
                if(_map) {
                    let helpTooltipElement = vars.helpTooltipElement;
                    if (helpTooltipElement && helpTooltipElement.parentNode) {
                        helpTooltipElement.parentNode.removeChild(helpTooltipElement);
                    }
                    helpTooltipElement = vars.helpTooltipElement = document.createElement('div');
                    helpTooltipElement.className = 'ol-tooltip hidden';
                    vars.helpTooltip = new Overlay({
                        id: vars.helpTooltipId,
                        element: helpTooltipElement,
                        offset: [15, 0],
                        positioning: 'center-left',
                    });
                    _map.addOverlay(vars.helpTooltip);
                }
            },
            createMeasureTooltip: function() {
                let _map = this.getMap();
                if(_map) {
                    let measureTooltipElement = vars.measureTooltipElement;
                    if (measureTooltipElement && measureTooltipElement.parentNode) {
                        measureTooltipElement.parentNode.removeChild(measureTooltipElement);
                    }
                    measureTooltipElement = vars.measureTooltipElement = document.createElement('div');
                    measureTooltipElement.className = 'ol-tooltip ol-tooltip-measure';
                    vars.measureTooltip = new Overlay({
                        id: vars.measureTooltipId,
                        element: measureTooltipElement,
                        offset: [0, -15],
                        positioning: 'bottom-center',
                        stopEvent: false,
                        insertFirst: false,
                    });
                    _map.addOverlay(vars.measureTooltip);
                }
            },
            removeTooltips: function() {
                let _map = this.getMap();
                if(_map) {
                    let helpTooltipElement = vars.helpTooltipElement;
                    if (helpTooltipElement && helpTooltipElement.parentNode) {
                        helpTooltipElement.parentNode.removeChild(helpTooltipElement);
                    }
                    vars.helpTooltipElement = null;

                    let measureTooltipElement = vars.measureTooltipElement;
                    if (measureTooltipElement && measureTooltipElement.parentNode) {
                        measureTooltipElement.parentNode.removeChild(measureTooltipElement);
                    }
                    vars.measureTooltipElement = null;

                    let _map = this.getMap();
                    if(_map) {
                        let overlays = _map.getOverlays();
                        let _arr = overlays.getArray();
                        for (let i = _arr.length - 1; i >= 0; i-- ) {
                            let id = _arr[i].getId();
                            if (id && [vars.helpTooltipId, vars.measureTooltipId].includes(id)) {
                                overlays.removeAt(i);
                            }
                        }
                        _map.clearSource(this.sourceId);
                    }
                }
            },
            clearMap: function() {
                this.removeTooltips();
                this.createMeasureTooltip();
                this.createHelpTooltip();
            },
            setMapLayer: function(remove=false) {
                const _map = this.getMap();
                if(!_map){
                    return;
                }
                const optionsLayer = this.layersProperties;
                let sourceId = this.sourceId;
                let layerId = this.layerId;
                let _source = _map.getSource(sourceId);
                let _layer = _map.getLayer(layerId);
                if(remove) {
                    if(_source){
                        _map.removeSource(sourceId);
                    }
                    if(_layer){
                        _map.removeLayer(_layer, layerId);
                    }
                }else{
                    if(!_layer){
                        if(!_source){
                            _source = _map.createVectorSource({});
                            _map.setSource(sourceId, _source);
                        }
                        let zIndex = Math.max(Math.max(..._map.getLayers().getArray().map(o => o.getZIndex())) + 1, optionsLayer.zindex);
                        _layer = _map.createVectorLayer({
                            source: _source,
                            zIndex: zIndex,
                            style: this.getStyle(),
                        });
                        _map.setLayer(layerId, _layer);
                        _map.addlayerToMap({layer: _layer});

                    }
                    _map.clearSource(sourceId);
                }
            },
            getStyle: function() {
                const _map = this.getMap();
                if(_map){
                    return _map.createStyle({
                        fill: {
                            color: 'rgba(255, 255, 255, 0.2)',
                        },
                        stroke: {
                            color: '#ffcc33',
                            width: 4,
                            lineCap:'square',
                            lineJoin:'round',
                        },
                        circle: {
                            radius: 7,
                            stroke: '#ffcc33',
                            fill: '#ffcc33',
                        },
                    });
                }
                return null;
            },
            setMapHandler: function(remove=false) {
                let _map = this.getMap();
                if(_map) {
                    let olMap = _map.getOLMap();
                    if(olMap) {
                        let viewport = olMap.getViewport();
                        const fnHelp = (evt) => {
                            let helpTooltipElement = vars.helpTooltipElement;
                            if(helpTooltipElement){
                                helpTooltipElement.classList.add('hidden');
                            }
                        }
                        if(remove) {
                            olMap.un(MapBrowserEventType.POINTERMOVE, this.pointerMoveHandler);
                            viewport.removeEventListener('mouseout', fnHelp);
                        }else{
                            olMap.on(MapBrowserEventType.POINTERMOVE, this.pointerMoveHandler);
                            viewport.addEventListener('mouseout', fnHelp);
                        }
                    }
                }
            },
            /**
             * Handle pointer move.
             * @param {import("ol/MapBrowserEvent").default} evt The event.
             */
            pointerMoveHandler: function (evt) {
                if (evt.dragging) {
                    return;
                }
                /** @type {string} */
                let helpMsg = vars.helpMsg;

                if (vars.sketch) {
                    const geom = vars.sketch.getGeometry();
                    if (geom instanceof Polygon) {
                        helpMsg = vars.continuePolygonMsg;
                    } else if (geom instanceof LineString) {
                        helpMsg = vars.continueLineMsg;
                    }
                }

                let helpTooltip = vars.helpTooltip;
                if(helpTooltip){
                    helpTooltip.setPosition(evt.coordinate);
                }

                let helpTooltipElement = vars.helpTooltipElement;
                if(helpTooltipElement) {
                    helpTooltipElement.innerHTML = helpMsg;
                    helpTooltipElement.classList.remove('hidden');
                }
            },
        },
        watch: {
            showModal: {
                immediate: false,
                handler(value, oldVal) {
                    if(value){
                        this.initialize();
                    }else{
                        this.reset();
                    }
                },
            },
        },
    }
</script>

<style lang="scss" scoped>
</style>

<style lang="scss">
    .modal-measure {
        .modal {
            top: 20%;
            left: calc(100% - 350px);
            width: 300px;
        }

        .btn i {
            font-size: 1rem;
        }
    }
    .ol-tooltip {
        position: relative;
        background: rgba(0, 0, 0, 0.5);
        border-radius: 4px;
        color: white;
        padding: 4px 8px;
        opacity: 0.7;
        white-space: nowrap;
        font-size: 12px;
        cursor: default;
        user-select: none;
    }
    .ol-tooltip-measure {
        opacity: 1;
        font-weight: bold;
    }
    .ol-tooltip-static {
        background-color: #ffcc33;
        color: black;
        border: 1px solid white;
    }
    .ol-tooltip-measure:before,
    .ol-tooltip-static:before {
        border-top: 6px solid rgba(0, 0, 0, 0.5);
        border-right: 6px solid transparent;
        border-left: 6px solid transparent;
        content: "";
        position: absolute;
        bottom: -6px;
        margin-left: -7px;
        left: 50%;
    }
    .ol-tooltip-static:before {
        border-top-color: #ffcc33;
    }
</style>